<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="py-0 px-3" cols="3">
        <label>Ordenar por</label>
        <v-select
          v-model="orderBy"
          :items="orderByList"
          item-value="valor"
          item-text="descricao"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
          @change="filterList({ ...filterData, ...orderBy }, 1)"
        ></v-select>
      </v-col>
      <v-spacer />
      <v-col class="d-flex justify-end pb-2 px-0 mb-0" cols="4" sm="6" xs="12">
        <v-btn
          color="primary"
          class="mb-0 mt-2"
          text
          @click="downloadFile('getcsvpagamentospublicados', filterData, true)"
          :disabled="list.length == 0"
        >
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar resultado
        </v-btn>
      </v-col>
    </v-row>
    <p class="text-center pt-6 pa-2" v-show="list.length === 0">
      Não há dados disponíveis
    </p>
    <v-row
      v-if="list.length > 0"
      class="ma-0 pl-4 pr-2"
      style="background-color: #d1dcea"
    >
      <v-col cols="2" class="pa-4">
        <div class="px-2 pt-1">
          <b class="pr-2">TOTAIS</b><br />
          <!-- <small class="py-n2">{{'('+(360000*100/400000).toFixed(1)+'% conciliado'}})</small> -->
        </div>
      </v-col>
      <v-col cols="10" class="pa-0">
        <v-row class="ma-0 pt-1 pr-11" style="justify-content: end">
          <v-col class="text-list text-right px-0 py-1" style="max-width: 12.6%"
            ><small>Informado</small><br /><b>{{
              totalData.valor_informado | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-right px-0 py-1" style="max-width: 8.6%"
            ><small>Conciliado</small><br /><b
              >{{ totalData.perc_conciliado | formatPrice }}%</b
            ></v-col
          >

          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Liberado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                totalData.valor_liberado | formatPrice
              }}</span></b
            ></v-col>

          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Recursado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                totalData.valor_recursado | formatPrice
              }}</span></b
            ></v-col
          >

          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Acatado</small><br /><b
              ><span style="color: red">{{
                totalData.valor_acatado | formatPrice
              }}</span></b
            ></v-col
          >

          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Lib. produção</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                totalData.valor_liberado_producao | formatPrice
              }}</span></b
            ></v-col
          >
          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Glosa inicial</small><br /><b
              ><span style="color: red">{{
                totalData.valor_glosado | formatPrice
              }}</span></b
            ></v-col
          >
          <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%"
            ><small>Lib. recurso</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                totalData.valor_liberado_recurso | formatPrice
              }}</span></b
            ></v-col
          >
          <v-col class="text-list text-right px-0 py-1" style="max-width: 12.6%"
            ><small>Glosa mantida</small><br /><b
              ><span style="color: red">{{
                totalData.valor_glosa_mantida | formatPrice
              }}</span></b
            ></v-col
          >
          <!-- <v-col style="max-width:10px"></v-col> -->
        </v-row>
      </v-col>
    </v-row>

    <p class="text-right ma-0 pa-0"><small>Valores em Reais (R$)</small></p>

    <v-expansion-panels focusable v-model="panel" v class="px-0 pt-3">
      <v-expansion-panel
        v-for="(pagamento, ind) in list"
        :key="ind"
        class="mb-4 pa-0"
        @click="
          pagamentoId = pagamento.id;
          getLotesPagamento(pagamento.id, { offset: 1 });
        "
      >
        <v-expansion-panel-header class="py-0 px-3">
          <v-row class="ma-0">
            <v-col cols="2" class="pa-0" style="max-width:130px">
              <div class="check-header-rec2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <v-btn
                        class="py-0 px-0"
                        color="primary"
                        small
                        icon
                        @click="
                          $event.stopPropagation();
                          pagamentoId = pagamento.id;
                        "
                        :to="`/recebiveis/pagamentospublicados/detalhespagamento/${pagamento.id}`"
                      >
                        <v-icon class="pa-0" small
                          >fas fa-external-link-alt</v-icon
                        >
                      </v-btn>
                    </span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                  >
                    Ver detalhes do pagamento
                  </span>
                </v-tooltip>
              </div>
              <div class="px-0 py-3 ml-7">
                <b class="pr-2"
                  ><small>Data do pagamento:</small><br />{{
                    pagamento.data_pagamento | formatDate
                  }}</b
                >
              </div>
            </v-col>
            <!-- <v-spacer/> -->
            <!-- <v-col cols="10" class="pa-0">
              <v-row class="ma-0"> -->
                <v-col
                  class="text-list text-left px-0 pt-3 pb-2"
                  style="min-width: 155px; max-width: 18%;"
                  ><b>{{ pagamento.oper_nome }}</b
                  ><br />{{ pagamento.prest_nome }}</v-col
                >
                <v-col class="text-list text-right px-1 py-3"
                  ><small>Informado</small><br /><b
                    ><span>{{
                      pagamento.valor_informado | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col
                  class="text-list text-right px-1 py-3"
                  style="max-width: 70px"
                  ><small>Conciliado</small><br /><b
                    >{{ pagamento.perc_conciliado }}%</b
                  ></v-col
                >
                <v-col class="text-list text-right px-1 py-3"
                  ><small>Liberado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado | formatPrice
                    }}</span></b
                  ></v-col
                >

                <v-col class="text-list text-right px-1 py-3"
                  ><small>Recursado</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_recursado | formatPrice
                    }}  </span></b
                  ></v-col
                >

                <v-col class="text-list text-right px-1 py-3"
                  ><small>Acatado</small><br /><b
                    ><span style="color: red"> {{
                      pagamento.valor_acatado | formatPrice
                    }}</span></b
                  ></v-col
                >

                <v-col class="text-list text-right px-1 py-3"
                  ><small>Lib. produção</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado_producao | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col class="text-list text-right px-1 py-3"
                  ><small>Glosa inicial</small><br /><b
                    ><span style="color: red">{{
                      pagamento.valor_glosado | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col class="text-list text-right px-1 py-3"
                  ><small>Lib. recurso</small><br /><b
                    ><span style="color: rgb(50, 184, 139)">{{
                      pagamento.valor_liberado_recurso | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col class="text-list text-right px-1 py-3"
                  ><small>Glosa mantida</small><br /><b
                    ><span style="color: red">{{
                      pagamento.valor_glosa_mantida | formatPrice
                    }}</span></b
                  ></v-col
                >
                <v-col
                  class="text-list text-right px-0 py-3"
                  style="max-width: 125px; min-width: 90px"
                >
                  <v-tooltip
                    bottom
                    open-delay="100"
                    v-if="!!pagamento.doc_id_resultado"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-3 mt-2"
                        color="primary"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          download($event, {
                            doc_id: pagamento.doc_id_resultado,
                          })
                        "
                        >fa-file-invoice
                      </v-icon>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Resultados</span
                    >
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    open-delay="100"
                    v-if="!!pagamento.doc_id_dac"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-3 mt-2"
                        color="primary"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          download($event, { doc_id: pagamento.doc_id_dac })
                        "
                        >fa-file-archive
                      </v-icon>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >DAC - Demonstrativo de Análise de Contas</span
                    >
                  </v-tooltip>
                  <!-- Check de quitação - INÍCIO -->
                  <v-tooltip bottom v-if="pagamento.quitado && !pagamento.itg_sdi">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-3 mt-3 mb-0"
                        color="success"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="quitarPagamentoConfirm($event, pagamento, true)"
                        >far fa-check-square</v-icon
                      >
                    </template>
                    <span
                      class="px-0 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Quitado - Clique para editar dados da quitação</span
                    >
                  </v-tooltip>

                  <v-tooltip bottom v-else-if="!isPermissaoQuitacao() && !pagamento.itg_sdi">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        class="mr-3 mt-3 mb-0"
                        @click="
                          quitarPagamentoConfirm($event, pagamento, false)
                        "
                        >far fa-square</v-icon
                      >
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Clique para quitar pagamento</span
                    >
                  </v-tooltip>
                  <!-- Check de quitação - FIM -->

                  <!-- Check de integração - INÍCIO (ícone)-->
                  <!-- Integracao  -->
                  <template v-if="pagamento.itg_sdi && pagamento.perc_conciliado > 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-3 mt-3 mb-0"
                          v-bind:color="statusIntegracao[pagamento.status_integracao_erp].cor"
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="pagamento.status_integracao_erp == 0 ? confirmarIntegracao($event, pagamento) : listarLogsIntegracao($event, pagamento, null, 1)"
                          >fa fa-exchange-alt
                        </v-icon>
                      </template>
                      <span
                        class="px-2 py-1 ma-0"
                        style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                        "
                        >{{statusIntegracao[pagamento.status_integracao_erp].descricao}}</span>
                    </v-tooltip>
                  </template>
                  <!-- Check de integração - FIM -->
                <!-- </v-col>
              </v-row> -->
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="lotesList"
            hide-default-footer
            :options.sync="options"
            class="pgtosLotesListTable"
            dense
          >
          <!-- Por lote -->
            <template v-slot:item.arq_nome="{ item }">
              <!-- <template>
                <v-tooltip bottom v-if="item.tipo_pagamento != null">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      x-small
                      :class="(item.tipo_pagamento==10)?'mr-0 mt-1 mb-1': 'mr-3 mt-1 mb-1'"
                      v-bind:color="primary"
                      v-bind="attrs"
                      v-on="on"
                      >fs fa-dollar-sign</v-icon>
                      <v-icon
                      v-if="item.tipo_pagamento==10"
                      x-small
                      class="ml--60 mr-3 mt-1 mb-1"
                      v-bind:color="primary"
                      v-bind="attrs"
                      v-on="on"
                      >fs fa-dollar-sign</v-icon>
                  </template>
                  <span
                    class="px-2 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{item.tipo_pagamento == 10? 'Pagamento de recurso' : 'Pagamento de produção' }}</span>
                </v-tooltip>
              </template> -->
              <template v-if="pagamento.itg_sdi">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      x-small
                      class="mr-3 mt-1 mb-1"
                      v-bind:color="statusIntegracao[item.status_integracao_erp].cor"
                      v-bind="attrs"
                      v-on="on"
                      @click="listarLogsIntegracao($event, pagamento, item.id, 1)"
                      >fa fa-exchange-alt</v-icon>
                  </template>
                  <span
                    class="px-2 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{statusIntegracao[item.status_integracao_erp].descricao}}</span>
                </v-tooltip>
              </template>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="pa-0">
                    {{ item.arq_nome }}
                  </span>
                </template>
                <span
                  class="px-3 py-1 ma-0"
                  style="
                    border: solid 1px #999;
                    border-radius: 5px;
                    background-color: #fff;
                  "
                  >{{ item.arq_nome }}</span
                >
              </v-tooltip>
            </template>
            <template v-slot:item.valor_informado="{ item }" class="px-1 py-0">
              <b>{{ item.valor_informado | formatPrice }}</b>
            </template>
            <template v-slot:item.valor_conciliado="{ item }">
              <b>{{ item.valor_conciliado | formatPrice }}</b> ({{
                item.perc_valor_conciliado
              }}
              %)
            </template>
            <template v-slot:item.valor_liberado="{ item }">
              <b style="color: green">{{
                item.valor_liberado | formatPrice
              }}</b>
              ({{ item.perc_valor_liberado }} %)
            </template>
            <template v-slot:item.valor_glosado="{ item }">
              <b style="color: red">{{ item.valor_glosado | formatPrice }}</b>
              ({{ item.perc_valor_glosado }} %)
            </template>
          </v-data-table>
          <p class="text-right"><small>Valores em Reais (R$)</small></p>
          <div class="text-center mt-n5 py-0 col-md-12">
            <v-pagination
              class="no-box-shadow"
              v-model="pageLotes"
              :length="lotesPagination.total_pages"
              @input="getLotesPagamento(pagamento.id, { offset: pageLotes })"
            ></v-pagination>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="text-center mt-2 py-0 col-md-12">
      <v-pagination
        v-if="list.length"
        class="no-box-shadow"
        v-model="pagination.offset"
        :length="pagination.total_pages"
        @input="filterList(filterData, pagination.offset)"
      ></v-pagination>
    </div>
    <QuitarPagamentoDlg
      :close="() => (showQuitarPagamento = false)"
      :dadosPagamento="dadosPagamento"
      :dadosQuitacao="dadosQuitacao"
      :dialog="showQuitarPagamento"
      :saveForm="(formData) => saveDadosQuitacao(formData)"
    />
    <LogsIntegracaoDlg
      :close="
        () => {
          showLogs = false;
          offsetLogs = 1;
          logsPagesTotal = 0; 
          logList = [];
        }
      "
      :dialog="showLogs"
      :lista="logList"
      :retry="(dadosPagamento) => integrarPagamento(dadosPagamento)"
      :dadosPagamento="dadosPagamento"
      :getLogs="(pagamento, loteId, currentPage) => listarLogsIntegracao(null, pagamento, loteId, currentPage)"
      :loteId="loteId"
      :totalPages="logsPagesTotal"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
moment.locale("pt-BR");
import QuitarPagamentoDlg from "./QuitarPagamentoDlg";
import LogsIntegracaoDlg from "./LogsIntegracaoDlg.vue";

export default {
  components: {
    QuitarPagamentoDlg,
    LogsIntegracaoDlg,
  },
  data() {
    return {
      baseURL: null,
      dadosPagamento: null,
      dadosQuitacao: null,
      totalData: null,
      list: [],
      statusIntegracao: {
        0 : {cor: "primary", descricao: "Não integrado"},
        1 : {cor: "#B2B842", descricao: "Em processamento"},
        2 : {cor: "#9154CD", descricao: "Aguardando baixa contábil"},
        3 : {cor: "#32B88B", descricao: "Integração finalizada"},
        "-1" : {cor: "#D0021B", descricao: "Falha na integração"},
        "-2" : {cor: "#FC9D0A", descricao: "Falha parcial na integração"}
      },
      lotesList: [],
      options: null,
      orderBy: { sort: "data_pagamento", order: "Desc" },
      orderByList: [
        {
          descricao: "Datas mais recentes",
          valor: { sort: "data_pagamento", order: "Desc" },
        },
        {
          descricao: "Datas mais antigas ",
          valor: { sort: "data_pagamento", order: "Asc" },
        },
        {
          descricao: "Maiores valores informado",
          valor: { sort: "valor_informado", order: "Desc" },
        },
        {
          descricao: "Menores valores informado",
          valor: { sort: "valor_informado", order: "Asc" },
        },
        {
          descricao: "Maiores percentuais conciliados",
          valor: { sort: "perc_conciliado", order: "Desc" },
        },
        {
          descricao: "Menores percentuais conciliados",
          valor: { sort: "perc_conciliado", order: "Asc" },
        },
        {
          descricao: "Maiores valores lib. de produção",
          valor: { sort: "valor_liberado_producao", order: "Desc" },
        },
        {
          descricao: "Menores valores lib. de produção",
          valor: { sort: "valor_liberado_producao", order: "Asc" },
        },
        {
          descricao: "Maiores valores de glosa",
          valor: { sort: "valor_glosado", order: "Desc" },
        },
        {
          descricao: "Menores valores de glosa",
          valor: { sort: "valor_glosado", order: "Asc" },
        },
        {
          descricao: "Maiores valores lib. de recurso",
          valor: { sort: "valor_liberado_recurso", order: "Desc" },
        },
        {
          descricao: "Menores valores lib. de recurso",
          valor: { sort: "valor_liberado_recurso", order: "Asc" },
        },
        {
          descricao: "Maiores valores de glosa mantida",
          valor: { sort: "valor_glosa_mantida", order: "Desc" },
        },
        {
          descricao: "Menores valores de glosa mantida",
          valor: { sort: "valor_glosa_mantida", order: "Asc" },
        },
      ],
      pagamentoId: null,
      pageLotes: 1,
      panel: null,
      headers: [
        {
          text: "Lotes conciliados",
          value: "arq_nome",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº lote",
          value: "arq_numero_lote",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Ident. na operadora",
          value: "identificador_prestador",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Protocolo",
          value: "env_op_protocolo",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº nota fiscal",
          value: "arq_nfs",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº Nfe",
          value: "arq_nfes",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Valor apresentado",
          value: "valor_informado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Valor conciliado",
          value: "valor_conciliado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Pagamento",
          value: "valor_liberado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Glosa",
          value: "valor_glosado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
      ],
      headersPagto: [
        {
          text: "Lotes conciliados",
          value: "arq_nome",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº lote",
          value: "arq_numero_lote",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Ident. na operadora",
          value: "identificador_prestador",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Protocolo",
          value: "env_op_protocolo",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº nota fiscal",
          value: "arq_nfs",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Nº nota fiscal eletrônica",
          value: "arq_nfes",
          align: "left",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Valor apresentado",
          value: "valor_informado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Valor conciliado",
          value: "valor_conciliado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Pagamento",
          value: "valor_liberado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
        {
          text: "Glosa",
          value: "valor_glosado",
          align: "right",
          class: "py-0",
          sortable: true,
        },
      ],
      showQuitarPagamento: false,
      logList: null,
      showLogs: false,
      offsetLogs: 1,
      loteId: '',
      logsPagesTotal: 1,
    };
  },
  watch: {
    lotes: {
      deep: true,
      handler(val) {
        this.lotesList = val ? val.dados : [];
      },
    },
    options(item) {
      this.pageLotes = 1;
      let sort = item.sortBy[0] ? item.sortBy[0] : null;
      let order =
        item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc" : "Asc") : null;
      let options = { offset: 1, sort, order };
      this.getLotesPagamento(this.pagamentoId, options);
    },
    pagamentos: {
      deep: true,
      handler(val) {
        if (val) {
          let {
            perc_conciliado,
            valor_glosado,
            valor_liberado,
            valor_recursado,
            valor_acatado,
            valor_liberado_recurso,
            valor_informado,
            valor_glosa_mantida,
            valor_liberado_producao,
          } = val;
          this.list = val.dados;
          this.totalData = {
            perc_conciliado,
            valor_glosado,
            valor_liberado,
            valor_recursado,
            valor_acatado,
            valor_liberado_recurso,
            valor_informado,
            valor_glosa_mantida,
            valor_liberado_producao,
          };
        } else {
          this.list = [];
        }
      },
    },
    filterData(val) {
      this.orderBy =
        !!val && val.sort
          ? this.orderByList.find(
              (el) =>
                el.valor &&
                el.valor.sort == val.sort &&
                el.valor.order == val.order
            ).valor
          : { sort: "data_pagamento", order: "Desc" };
    },
  },
  computed: {
    ...mapState({
      permissaoAcao: state => state.userData.userData.PermissaoAcoes
    }),
  },
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument",
    }),
    download(e, docData) {
      e.stopPropagation();
      this.getDocument(docData);
    },
    downloadFile(acao, filterData, doCallBack) {
      this.$store.commit("showLoader", { circle: true }, {root: true});
      // if(this.pagination.total_pages > 100){
      //     let paramModal = {
      //     type: "warning",
      //     title: "Tamanho de arquivo excedido",
      //     message: `<p>Restrinja a sua busca para fazer o download do resultado</p>`,
      //     callback: null,
      //     btConfirm: { name: "", show: false },
      //     btCancel: { name: "Ok", show: true },
      //   };
      //   this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      //   return
      // }

      let Payload = {...filterData }
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: doCallBack? ()=> setTimeout(()=>{
        this.filterList(this.filterData, this.pagination.offset)
        //this.$store.commit("hideLoader");
        }, 500) : null }, {root:true})
    },
    quitarPagamentoConfirm(e, pagamento, isQuitado) {
      e.stopPropagation();
      this.dadosPagamento = pagamento;
      let pagamento_publicado_id = pagamento.id;
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      if (isQuitado) {
        let obj = {
          query: [
            {
              Modulo: "Recebiveis",
              Acao: "getdadosquitacao",
              Payload: {
                pagamento_publicado_id,
                grupo_economico,
              },
            },
          ],
        };
        this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit("hideLoader");
            return;
          }
          let { valor_pago_liquido, valor_imposto, valor_desconto, data_credito, acao } = response;
          this.dadosPagamento = {
            ...pagamento,
            acao,
            data_credito, 
            valor_pago_liquido,
            valor_imposto,
            valor_desconto
          };
          this.showQuitarPagamento = true;
        });
      } else {
        this.showQuitarPagamento = true;
      }
    },
    saveDadosQuitacao(formData) {
      this.$store.commit("showLoader", { circle: true });
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "savedadosquitacao",
            Payload: {
              ...formData,
              grupo_economico,
            },
          },
        ],
        noLoader: true,
      };
        this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit("hideLoader");
            return;
          }
          this.$store.commit("hideLoader");
          let paramModal = {
            type: "success",
            title: "Sucesso!",
            message: response.mensagem,
            callback: () => { 
                              this.filterList(this.filterData, this.pagination.offset);
                              this.showQuitarPagamento = false;
                            },
            btConfirm: { name: "OK", show: true, color: "primary" },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });
    },
    // quitarPagamento(pagamento_id, grupo_economico) {
    //   let obj = {
    //     query: [
    //       {
    //         Modulo: "Recebiveis",
    //         Acao: "updatepagamentospublicados",
    //         Payload: { grupo_economico, pagamento_id },
    //       },
    //     ],
    //   };
    //   this.$store.dispatch("request/doRequest", obj).then((response) => {
    //     if (!response || response.isAxiosError || !response.sucesso) {
    //       this.$store.commit("hideLoader");
    //       return;
    //     }
    //     let paramModal = {
    //       type: "success",
    //       title: "Sucesso!",
    //       message: response.mensagem,
    //       callback: () => {
    //         this.filterList(this.filterData, this.pagination.offset);
    //         this.showQuitarPagamento = false;
    //       },
    //       btConfirm: { name: "OK", show: true, color: "primary" },
    //     };
    //     this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    //   });
    // },
    totalPages() {
      let total = this.lotesList
        ? parseInt(this.lotesList.length / this.lotesPagination.limit)
        : 0;
      total = total % this.lotesPagination.limit > 0 ? total : total;
      this.lotesPagination.total_pages = total == 0 ? 1 : total;
      return this.lotesPagination.total_pages;
    },
    confirmarIntegracao(e, pagamento) {
      e.stopPropagation();

      let paramModal = {
          type: "info",
          title: "Confirma integração do pagamento?",
          message: "Confirme a integração do pagamento selecionado.",
          callback: () => {
            this.integrarPagamento(pagamento);
          },
          btConfirm: { name: "Confirmar", show: true, color: "primary" },
          btCancel: { name: "Cancelar", show: true, color: "primary"},
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    integrarPagamento(pagamento) {
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "concluirintegracaosdi",
            Payload: { grupo_economico, pagamento_id: pagamento.id, prestador_id: pagamento.prestador_id },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.filterList(this.filterData, this.pagination.offset);
            this.showQuitarPagamento = false;
          },
          btConfirm: { name: "OK", show: true, color: "primary" },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    listarLogsIntegracao(e, pagamento, loteId = null, currentPage) {
      if (e !== null) e.stopPropagation();
      this.dadosPagamento = pagamento;
      this.loteId = loteId;
      this.offsetLogs = currentPage;
      let grupo_economico = this.$store.state.permissions.grupoEconomico;
      let Acao = loteId == null ? 'getlogintegracaobypagto' : 'getlogintegracao';
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao : Acao,
            Payload: { grupo_economico, lote_id: loteId, pagamento_id: pagamento.id, offset: this.offsetLogs, limit: 10 },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.logsPagesTotal = response.total_pages;
        console.log("response.dados",response.dados)
        this.logList = response.dados;
        this.showLogs = true;
        this.$nextTick();
      });
    },
    isPermissaoQuitacao(){
      //verifica se o usuário em questão tem ação a esse endpoint e libera a ação.
      this.permissaoAcao.recebiveis.includes("savedadosquitacao");
    }
  },
  props: {
    getLotesPagamento: Function,
    lotes: Object,
    lotesPagination: Object,
    pagamentos: Object,
    pagination: Object,
    filterData: Object,
    filterList: Function,
  },
  filters: {
    formatNullValue(val) {
      return val ? val : "-";
    },
  },
};
</script>

<style lang="scss">
.no-box-shadow,
.no-box-shadow * {
  box-shadow: 0 0 0 0 !important;
}
button.v-expansion-panel-header {
  background-color: #eff3f8;
  border-radius: 2px;
  padding: 0;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel::after {
  display: none;
}
.v-expansion-panel-content {
  display: flex;
  margin: 0 -24px;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.text-list {
  font-size: 13px;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.check-header-rec {
  position: absolute;
  margin-top: 9px;
  margin-left: 3px;
}
.check-header-rec2 {
  position: absolute;
  margin-top: 10px;
  margin-left: -4px;
}
.check-content {
  position: absolute;
  margin-top: -16px;
}
.check-border {
  border: none;
}
.porcentagem {
  border-radius: 8px;
  padding: 0 0 0 0;
  text-align: center;
  width: 100%;
  border: 1.5px solid #9e9e9e;
  font-size: 12px;
  color: #9e9e9e;
}
.v-expansion-panel-header .row {
  align-items: center;
}
.v-chip {
  border-bottom-style: solid;
  left: 0.8rem;
}
.v-chip:nth-child(3) {
  margin-left: 0.3rem;
}
.v-chip:last-child {
  margin-left: 0.3rem;
}
#check-color {
  .v-icon.v-icon {
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #118aca;
  }
}
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child,
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>